import { render, staticRenderFns } from "./CdpGroup.vue?vue&type=template&id=35853b11&"
import script from "./CdpGroup.vue?vue&type=script&lang=ts&"
export * from "./CdpGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports